const NullComponent = () => {
  return null;
};

export default NullComponent;
